module.exports = __webpack_public_path__ + "media/images/icons/clock-icon-50bfda43110deac49c77273cbaeb6628.svg";